import { graphql } from 'react-relay/legacy';

export const privacyPolicyChangeNoticeQuery = graphql`
    query privacyPolicyChangeNoticeQuery($userId: String!, $hasSessionCountryCode: Boolean!) {
        viewer {
            user(userId: $userId) {
                createdDate
            }
            regionalInfo @skip(if: $hasSessionCountryCode) {
                countryCode
            }
        }
    }
`;
